const SUFFIX = "$";
export const ERROR_EXPIRED_TOKEN = `ERROR_EXPIRED_TOKEN${SUFFIX}`;
//# sourceMappingURL=errors.js.map